import { render, staticRenderFns } from "./ContestPlayer.vue?vue&type=template&id=4157d9bc&scoped=true&"
import script from "./ContestPlayer.vue?vue&type=script&lang=js&"
export * from "./ContestPlayer.vue?vue&type=script&lang=js&"
import style0 from "./ContestPlayer.vue?vue&type=style&index=0&id=4157d9bc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4157d9bc",
  null
  
)

export default component.exports